// extracted by mini-css-extract-plugin
export var checkbox = "_6t-0";
export var circle = "_6t-3";
export var horizontalContainer = "_6t-7";
export var sm = "_6t-5";
export var switch0 = "_6t-2";
export var switchDisabled = "_6t-8";
export var switchEnabled = "_6t-1";
export var textSwitchContainer = "_6t-9";
export var textSwitchOption = "_6t-a";
export var textSwitchOptionSelected = "_6t-b";
export var verticalContainer = "_6t-6";
export var xs = "_6t-4";